
window.addEventListener('DOMContentLoaded', function() {
    let $select = document.getElementById("address-autocomplete");
    let $address = document.getElementById("address-input");
    let $citycode = document.getElementById("citycode-input");
    $address.addEventListener("input", autocompleteAdresse, false);
    function displaySelection(response) {
        if (Object.keys(response.features).length > 0) {
            $select.style.display = "block";
            $select.innerHTML = "";
            var $ul = document.createElement('ul');            
            response.features.forEach(function (element) {
                var $li = document.createElement('li');
                var $span = document.createElement('span');
                $span.innerHTML = "<b>"+element.properties.postcode + '</b> ' + element.properties.city;
                $li.appendChild($span);
                $li.onclick = function () { 
                    $citycode.value = element.properties.citycode;
                    $address.value = element.properties.postcode + ' ' + element.properties.city;
                    $select.style.display = "none";
                    _theAddress = element;
                    $address.dispatchEvent(new CustomEvent("address_change"));
                };
                $ul.appendChild($li);
            });
            $select.appendChild($ul);
        } else {
            $select.style.display = "none";
        }
    }
    function autocompleteAdresse() {
        var inputValue = $address.value;
        if (inputValue.length >= 3) {
            fetch('https://api-adresse.data.gouv.fr/search/?limit=15&type=municipality&q='+inputValue)
                .then(function (response) {
                    response.json().then(function (data) {
                        displaySelection(data);
                    });
                });
        } else {
            $select.style.display = "none";
        }
    }
});